import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import defaultTheme from '@vr/lib/styles/theme';
import GlobalStyles from '../styles/GlobalStyles';
import { VRPAT, JVCEF } from '../config/constants';

export const jvcefTheme = {
  ...defaultTheme,
  colors: {
    ...defaultTheme.colors,
    primary: '#195C9D',
    secondary: '#EA8A3A',
    institucional: '#195C9D',
    institucionalDark: '#195C9D',
    institucionalLight: '#195C9D',
  },
};

const themes = {
  [VRPAT]: defaultTheme,
  [JVCEF]: jvcefTheme,
};

export default function AppProvider({ children, issuer }) {
  return (
    <ThemeProvider theme={themes[issuer]}>
      {children}
      <GlobalStyles />
    </ThemeProvider>
  );
}

AppProvider.propTypes = {
  children: PropTypes.element.isRequired,
  issuer: PropTypes.string.isRequired,
};
